<!-- Overlay de Connexion -->
<div class="mat-overlay-spinner" *ngIf="progress.loading" fxLayout="column" fxLayoutAlign="center center">
    <mat-spinner diameter="60"></mat-spinner>
    <div class="mat-body-2 mat-padding-small">{{progress.label}}</div>
</div>
<!-- Fin Overlay -->